import React, { useState } from 'react';
import { articlesAPI } from '../services/api';
import RichTextEditor from '../components/RichTextEditor';
import ImageUploader from '../components/ImageUploader';
import './AdminPanel.css';


function AdminPanel() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [article, setArticle] = useState({
    title: '',
    subtitle: '',
    content: '',
    author: '',
    category: 'Film',
    image: '',
    publishDate: new Date().toISOString().split('T')[0]
  });

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === process.env.REACT_APP_ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setPassword('');
    } else {
      alert('Incorrect password!');
      setPassword('');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  // Show login form if not authenticated
  if (!isAuthenticated) {
    return (
      <div className="admin-panel">
        <div className="login-container">
          <h1>🔒 Admin Access</h1>
          <p>This area is restricted to authorized personnel only.</p>
          <form onSubmit={handleLogin} className="login-form">
            <div className="form-group">
              <label>Admin Password:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                required
              />
            </div>
            <button type="submit" className="login-btn">Access Admin Panel</button>
          </form>
          <p className="security-note">⚠️ Unauthorized access is prohibited</p>
        </div>
      </div>
    );
  }

  const categories = ['Film', 'TV', 'Awards', 'Festivals', 'Reviews'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      let finalImageUrl = article.image;
      
      // Upload main image if it's a file object
      if (typeof article.image === 'object' && article.image.file) {
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result.split(',')[1]);
          reader.readAsDataURL(article.image.file);
        });
        
        const uploadResponse = await fetch(`${process.env.REACT_APP_AWS_API_URL}/upload-image`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            image: base64,
            fileName: article.image.fileName,
            contentType: article.image.contentType
          })
        });
        
        if (!uploadResponse.ok) {
          throw new Error('Failed to upload main image to S3');
        }
        
        const uploadResult = await uploadResponse.json();
        if (uploadResult.success) {
          finalImageUrl = uploadResult.imageUrl;
        } else {
          throw new Error('Main image upload failed');
        }
      }
      
      // Upload additional images
      const additionalImageUrls = [];
      
      // Format content to ensure proper paragraphs
      const formattedContent = article.content.includes('<p>') 
        ? article.content 
        : article.content.split('\n\n').filter(p => p.trim()).map(p => `<p>${p.trim()}</p>`).join('');
      
      const articleToSubmit = {
        ...article,
        content: formattedContent,
        image: finalImageUrl || 'https://via.placeholder.com/600x400',
        publishTime: article.publishDate ? new Date(article.publishDate).toISOString() : new Date().toISOString(),
        publishDate: article.publishDate
      };
      
      const response = await articlesAPI.createArticle(articleToSubmit);
      
      if (response.success) {
        alert('✅ Article published successfully!');
        // Reset form
        setArticle({
          title: '',
          subtitle: '',
          content: '',
          author: '',
          category: 'Film',
          image: '',
          publishDate: new Date().toISOString().split('T')[0]
        });
      }
    } catch (error) {
      alert('❌ Error creating article: ' + error.message);
    }
  };

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <h1>Add New Article</h1>
        <button onClick={handleLogout} className="logout-btn">Logout</button>
      </div>
      <form onSubmit={handleSubmit} className="article-form">
        <div className="form-group">
          <label>Title:</label>
          <input
            type="text"
            value={article.title}
            onChange={(e) => setArticle({...article, title: e.target.value})}
            required
          />
        </div>

        <div className="form-group">
          <label>Subtitle:</label>
          <input
            type="text"
            value={article.subtitle}
            onChange={(e) => setArticle({...article, subtitle: e.target.value})}
            required
          />
        </div>

        <div className="form-group">
          <label>Category:</label>
          <select
            value={article.category}
            onChange={(e) => setArticle({...article, category: e.target.value})}
          >
            {categories.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Author:</label>
          <input
            type="text"
            value={article.author}
            onChange={(e) => setArticle({...article, author: e.target.value})}
            required
          />
        </div>

        <div className="form-group">
          <label>Publish Date:</label>
          <input
            type="date"
            value={article.publishDate}
            onChange={(e) => setArticle({...article, publishDate: e.target.value})}
            required
          />
        </div>

        <div className="form-group">
          <label>Main Article Image:</label>
          <ImageUploader 
            currentImage={article.image}
            onImageUrl={(url) => setArticle({...article, image: url})}
          />
        </div>



        <div className="form-group">
          <label>Content:</label>
          <RichTextEditor
            value={article.content}
            onChange={(content) => setArticle({...article, content})}
            placeholder="Write your article content here. Use the toolbar to add links, images, and YouTube videos."
          />
        </div>

        <button type="submit" className="submit-btn">Publish Article</button>
      </form>
    </div>
  );
}

export default AdminPanel;